import { Page } from '@/core/architecture'

import { ManagementTemplate } from './template'
import { useViewModel } from './viewModel'

export const Management: Page = () => {
  const { state } = useViewModel()

  return <ManagementTemplate state={state} />
}
